module.exports = __webpack_public_path__ + "img/calculator-banner.96eef0c4.png";